<template>
  <content-form></content-form>
</template>

<script>
  import contentForm from './form'
  export default {
    components: {
      contentForm
    }
  }
</script>



// WEBPACK FOOTER //
// add.vue?138baac1